/**
 * @author      patrick@zumper.com (Patrick Giddings)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type { RentResearchHomepage } from '@zcode/state-type'

export const RENT_RESEARCH_HOMEPAGE_SLICE_NAME = 'rentResearchHomepage'

export const RENT_RESEARCH_HOMEPAGE_INITIAL_STATE: RentResearchHomepage = {
  rentalData: null,
  linkpacks: {
    address: null,
    building: null,
    afrCity: null,
    afrNeighborhood: null,
    hfrCity: null,
    hfrNeighborhood: null,
    rfrCity: null,
    rfrNeighborhood: null,
  },
}
